import React from 'react'
import AutoComplete from 'material-ui/AutoComplete'
import * as colors from "material-ui/styles/colors";

import {
    isMobile
} from "react-device-detect";

class FormAutoComplete2 extends React.Component {

  render() {

    const {
      input,
      label,
      dataSource,
      onNewRequest,
      onUpdateInput,
      meta: { touched, error },
      ...custom
    } = this.props

    return ( 
      <AutoComplete
        menuStyle={{ width: 500, maxHeight: 500, }}
        listStyle={{ width: 500, maxHeight: 500, overflow: 'auto' }}
        dataSource={dataSource}
        floatingLabelStyle={{color: colors.grey600}}
        floatingLabelFixed
        floatingLabelText={label}
        errorText={touched && error}
        searchText={input.value}
        openOnFocus={true}
        onNewRequest={ (value, index) => {
          input.onChange(value.valueKey)
          if (onNewRequest) {
            onNewRequest(value, index)
          }
        }}
        onUpdateInput = { value => {
          if (onUpdateInput) {
            onUpdateInput(value)
          }
          input.onChange(value)
        }}
        {...input}
        {...custom}
      />
    )
  }
}

export default FormAutoComplete2


// WEBPACK FOOTER //
// ./src/components/FormAutoComplete2.js